module.exports = __webpack_public_path__ + "media/images/illustrations/unlimited_materials_boxes-b58d52b59c36ccb75bdea76eff02a272.svg";